// extracted by mini-css-extract-plugin
module.exports = {"root":"LimitsPermitModal_root__2rScK","content":"LimitsPermitModal_content__3pdyn","title":"LimitsPermitModal_title__2szr6","text":"LimitsPermitModal_text__1JHey"};